<div class="flex gap-1 mb-[40px]">
  <div *ngFor="let step of steps" class="flex-1 h-[4px] bg-grayscale-400" [class.bg-lime-regular]="step < currentStep"></div>
</div>
